import { useGetActiveVisualisationSettings } from 'utils/hooks/visualisation/getActiveVisualisationSettings';
import { EventsSettings } from 'modules/settingsContainer/common/EventsSettings';
import { onEventsChange } from 'modules/visualisations/components/EventsComponent/constants';

export const EventsComponent = () => {
  const { events } = useGetActiveVisualisationSettings();

  return <EventsSettings value={events} onChange={onEventsChange} />;
};
